var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('table',{staticClass:"table table-sm table-striped mb-0"},[_c('thead',[_c('tr',[_vm._t("columns")],2)]),_vm._v(" "),_c('tbody',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }